/**
 * Normaliza valores de operadora retornados pela API externa
 * para o formato aceito pelo enum operadora_doadora_enum no banco
 * 
 * Exemplos:
 * - "CLARO SMP" → "CLARO"
 * - "TIM BRASIL" → "TIM"
 * - "VIVO CELULAR" → "VIVO"
 * - "NET" → "CLARO" (telefonia fixa)
 * - "GVT" → "VIVO" (telefonia fixa)
 */
export function normalizarOperadora(operadora: string | null | undefined): string | null {
  if (!operadora || operadora === 'INVALIDO') {
    return null;
  }

  const upper = operadora.toUpperCase().trim();

  // Tratar "DESCONHECIDO" e "ERRO" como null para forçar reconsulta
  if (upper === 'DESCONHECIDO' || upper === 'ERRO') {
    return null;
  }

  // ✅ NOVO: "FIXO" é um valor válido para FIBRA (linha fixa sem operadora identificada)
  if (upper === 'FIXO') {
    return 'FIXO';
  }

  // ✅ NOVO: Operadoras de Telefonia Fixa
  if (upper.includes('NET') || upper.includes('CLARO FIXO') || upper.includes('EMBRATEL')) return 'CLARO';
  if (upper.includes('GVT') || upper.includes('VIVO FIXO') || upper.includes('TELEFONICA') || upper.includes('TELEFÔNICA')) return 'VIVO';
  if (upper.includes('OI FIXO') || upper.includes('TELEMAR') || upper.includes('BRT')) return 'OI';
  if (upper.includes('ALGAR FIXO') || upper.includes('CTBC')) return 'ALGAR';

  // Mapeamento de operadoras móveis (existente)
  if (upper.startsWith('CLARO')) return 'CLARO';
  if (upper.startsWith('TIM')) return 'TIM';
  if (upper.startsWith('OI')) return 'OI';
  if (upper.startsWith('VIVO')) return 'VIVO';
  if (upper.startsWith('NEXTEL')) return 'NEXTEL';

  // Fallback para operadoras desconhecidas
  return 'OUTRA';
}
